import case01Treatment from "../assets/caseStudies/case01-treatment.jpg";
import case01Thermal from "../assets/caseStudies/case01-thermal.jpg";
import case01Dry from "../assets/caseStudies/case01-day3-dry.jpg";
import case01Rewater from "../assets/caseStudies/case01-rewater.jpg";
import case01Analysis from "../assets/caseStudies/case01-analysis.png";

import case02Plant0630 from "../assets/caseStudies/case02-0630-plant.jpg";
import case02Plant0930 from "../assets/caseStudies/case02-0930-plant.jpg";
import case02Plant1130 from "../assets/caseStudies/case02-1130-plant.jpg";
import case02Temperature451 from "../assets/caseStudies/case02-temperature-451.jpg";
import case02Analysis0630 from "../assets/caseStudies/case02-0630-analysis.png";
import case02Analysis0930 from "../assets/caseStudies/case02-0930-analysis.png";
import case02Analysis1130 from "../assets/caseStudies/case02-1130-analysis.png";
import case02Plant0714 from "../assets/caseStudies/case02-0714-plant.jpg";
import case02Analysis0714 from "../assets/caseStudies/case02-0714-analysis.png";

import case03Chart from "../assets/caseStudies/case03-morning-response.png";
import case03Flyer from "../assets/caseStudies/case03-flyer-ja.png";
import case03FlyerPdf from "../assets/caseStudies/case03-flyer-ja.pdf";

import case04Hero from "../assets/caseStudies/case04-hero-bigdata.svg";


export const CASE_STUDIES = [
  {
    id: "01",
    path: "/case-studies/01",
    kicker: "TREATMENT × WATER RESPONSE",
    title: "気孔状態と、その後の水分応答",
    shortTitle: "気孔を見ると、その後が見えてくる。",
    summary:
      "ABA・カリウム・水処理後の気孔状態と、3日間の無灌水、再灌水後の外観変化を同じ時間軸で追跡した探索的事例です。",
    image: case01Treatment,
    tags: ["ABA", "カリウム", "無灌水", "再灌水"],
    featuredValue: "5.5–98.2%",
    featuredLabel: "Open率の範囲",
  },
  {
    id: "02",
    path: "/case-studies/02",
    kicker: "DRY-DOWN × REWATERING",
    title: "乾くと、気孔応答の違いが見えてきた。",
    shortTitle: "灌水・乾燥・再灌水を追跡し、別日の乾燥観察も照合。",
    summary:
      "7/16の灌水→培地乾燥→再灌水を3時点で追跡し、7/14の無灌水・萎れ条件を関連観察として併記しました。",
    image: case02Plant0930,
    tags: ["灌水", "培地乾燥", "再灌水", "2日観察"],
    featuredValue: "4,605",
    featuredLabel: "2日間で解析した気孔数",
  },
  {
    id: "03",
    path: "/case-studies/03",
    kicker: "FIELD PHYSIOLOGY × HIGH-THROUGHPUT",
    title: "商業栽培トマト圃場での大量計測",
    shortTitle: "296葉・14,563気孔を約5.5時間でデータ化。",
    summary:
      "2026年2月19日6:30〜12:00、同一栽培条件の多数株から異なる葉をランダムにサンプリングし、気孔・光合成・環境を同じ時間軸で追跡しました。",
    image: case03Flyer,
    tags: ["296葉", "14,563気孔", "光合成", "日周変化"],
    featuredValue: "2,647",
    featuredLabel: "約気孔 / 時間",
  },
  {
    id: "04",
    path: "/case-studies/04",
    image: case04Hero,
    kicker: "STOMATAL BIG DATA × ENVIRONMENT",
    title: "18,582個の気孔から、何が見える？",
    description:
      "Open率、Aperture、Pore Area、Short/Longを画像・時間単位で加工し、日射・温度・VPD・灌水データと統合して解析しました。",
    tags: ["18,582気孔", "Aperture", "Pore Area", "環境解析"],
    value: "18,582",
    valueLabel: "解析した気孔数",
  },
];

export const CASE01 = {
  id: "01",
  title: "気孔状態と、その後の水分応答",
  lead:
    "ABA・カリウム・水の3処理を行ったトマト苗について、処理後の気孔状態、3日間の無灌水後、再灌水後の外観を追跡しました。",
  question:
    "処理直後に観察された気孔開閉の違いは、その後の水分応答とどのように並んで現れるのか。",
  images: {
    treatment: case01Treatment,
    thermal: case01Thermal,
    dry: case01Dry,
    rewater: case01Rewater,
    analysis: case01Analysis,
  },
  results: [
    {
      key: "aba",
      label: "ABA",
      position: "左",
      detected: 108,
      open: 6,
      closed: 102,
      openRate: 5.5,
      median: 0.0,
      mean: 0.14,
      sd: 0.61,
      q1: 0.0,
      q3: 0.0,
    },
    {
      key: "potassium",
      label: "カリウム",
      position: "中央",
      detected: 167,
      open: 164,
      closed: 3,
      openRate: 98.2,
      median: 5.03,
      mean: 5.17,
      sd: 1.63,
      q1: 4.22,
      q3: 6.24,
    },
    {
      key: "control",
      label: "水（Control）",
      position: "右",
      detected: 139,
      open: 111,
      closed: 28,
      openRate: 79.8,
      median: 3.37,
      mean: 3.19,
      sd: 1.94,
      q1: 2.37,
      q3: 4.59,
    },
  ],
  test: {
    name: "Kruskal–Wallis",
    pValue: "< 0.0001",
    interpretation:
      "3群の少なくともいずれかで、気孔開度分布が異なることを示します。どの2群間が異なるかの判定には多重比較が必要です。",
  },
  timeline: [
    { time: "Day 0", title: "処理", text: "ABA／カリウム／水" },
    { time: "Day 0", title: "気孔解析", text: "Open / Closed・開度" },
    { time: "Day 0–3", title: "灌水停止", text: "無灌水条件で観察" },
    { time: "Day 3 12:05", title: "灌水前", text: "外観を撮影" },
    { time: "Day 3", title: "再灌水", text: "撮影後に灌水" },
    { time: "Day 3 17:07", title: "灌水後", text: "回復状態を撮影" },
  ],
};

export const CASE02 = {
  id: "02",
  title: "乾くと、気孔応答の違いが見えてきた。",
  lead:
    "7月16日の灌水→培地乾燥→再灌水を3時点で追跡し、7月14日の無灌水・萎れ条件を関連観察として照合しました。Control・バイオスティミュラントA剤・B剤のOpen率と気孔開度分布を、外観写真と同じ時間軸で確認します。",
  question:
    "根域水分が変化するとき、3処理区のOpen率と気孔開度分布はどう推移するのか。また、別日の培地乾燥・萎れ条件でも同じ応答パターンが現れるのか。",
  observationDates: 2,
  primaryTotalImages: 39,
  primaryTotalStomata: 3782,
  totalImages: 47,
  totalStomata: 4605,
  images: {
    hero: case02Plant0930,
    morningPlant: case02Plant0630,
    dryPlant: case02Plant0930,
    rewaterPlant: case02Plant1130,
    temperature: case02Temperature451,
    morningAnalysis: case02Analysis0630,
    dryAnalysis: case02Analysis0930,
    rewaterAnalysis: case02Analysis1130,
    relatedPlant: case02Plant0714,
    relatedAnalysis: case02Analysis0714,
  },
  environmentalRecord: {
    time: "11:23頃",
    value: 45.1,
    unit: "°C",
    note:
      "温度計表示を写真で記録した単一点の値。測定時間帯全体の平均気温や葉温を示すものではありません。",
  },
  treatments: {
    control: { label: "Control", shortLabel: "Control" },
    a: {
      label: "バイオスティミュラントA剤",
      shortLabel: "A剤",
    },
    b: {
      label: "バイオスティミュラントB剤",
      shortLabel: "B剤",
    },
  },
  timeline: [
    {
      time: "約04:00",
      title: "十分に灌水",
      text: "朝の測定前に、各区へ十分な灌水を実施。",
      kind: "irrigation",
      badge: "IRRIGATION",
    },
    {
      time: "06:25–06:34",
      title: "測定①",
      text: "灌水後の開始点として、3処理区の気孔を撮影・解析。",
      kind: "measurement",
      badge: "p = 0.4511",
    },
    {
      time: "09:22–09:36",
      title: "測定②：培地乾燥",
      text: "培地が乾燥した時点で、同じ3処理区を再測定。",
      kind: "dry",
      badge: "p < 0.0001",
    },
    {
      time: "約10:00",
      title: "十分に再灌水",
      text: "乾燥時の測定後、各区へ十分な灌水を実施。",
      kind: "irrigation",
      badge: "REWATERING",
    },
    {
      time: "11:24–11:40",
      title: "測定③：再灌水後",
      text: "再灌水から約1時間半後の気孔状態を撮影・解析。",
      kind: "measurement",
      badge: "p < 0.0001",
    },
  ],
  timepoints: [
    {
      key: "0630",
      label: "6:30頃",
      shortLabel: "06:30",
      window: "06:25:57–06:34:40",
      substrate: "約4:00の十分灌水後",
      pValue: 0.4510693318,
      pDisplay: "p = 0.4511",
      significant: false,
      eyebrow: "STARTING POINT / AFTER IRRIGATION",
      title: "十分に灌水された朝、3区の気孔開度分布は近かった。",
      description:
        "4:00頃に十分な灌水を行った後の開始点です。3区の中央値は2.82〜2.86 µmに収まり、群間差は認められませんでした。",
      plantImage: case02Plant0630,
      analysisImage: case02Analysis0630,
      plantCaption:
        "06:27頃の植物体写真。気孔画像は06:25:57〜06:34:40に取得しました。",
      analysisCaption:
        "Control、A剤、B剤の中央値はそれぞれ2.85、2.82、2.86 µm。Open率は72.6、81.6、81.5%でした。",
      statisticsNote:
        "この時点では、3群の気孔開度分布に統計的な差は認められませんでした。",
      results: [
        {
          key: "control",
          label: "Control",
          images: 4,
          detected: 379,
          open: 275,
          closed: 104,
          openRate: 72.5594,
          median: 2.84605,
          mean: 2.42038,
          sd: 1.65952,
          q1: 0.0,
          q3: 3.6,
        },
        {
          key: "a",
          label: "バイオスティミュラントA剤",
          images: 4,
          detected: 425,
          open: 347,
          closed: 78,
          openRate: 81.6471,
          median: 2.81745,
          mean: 2.54893,
          sd: 1.39149,
          q1: 2.25,
          q3: 3.33,
        },
        {
          key: "b",
          label: "バイオスティミュラントB剤",
          images: 4,
          detected: 454,
          open: 370,
          closed: 84,
          openRate: 81.4978,
          median: 2.86378,
          mean: 2.60386,
          sd: 1.42389,
          q1: 2.25,
          q3: 3.42118,
        },
      ],
    },
    {
      key: "0930",
      label: "9:30頃",
      shortLabel: "09:30",
      window: "09:22:01–09:36:01",
      substrate: "培地乾燥を確認",
      pValue: 1.1363861393e-31,
      pDisplay: "p < 0.0001",
      significant: true,
      eyebrow: "DRY PHASE / SUBSTRATE DRYING",
      title: "培地が乾くと、ControlとA剤・B剤の気孔応答が大きく分岐した。",
      description:
        "培地乾燥時、ControlではClosedが過半数となり中央値は0.00 µm。一方、A剤とB剤は約95% Open、中央値は約4.13 µmでした。",
      plantImage: case02Plant0930,
      analysisImage: case02Analysis0930,
      plantCaption:
        "09:24頃の植物体写真。測定時には培地乾燥を確認していました。",
      analysisCaption:
        "ControlはOpen率42.3%、中央値0.00 µm。A剤・B剤はOpen率約95%、中央値約4.13 µmでした。",
      statisticsNote:
        "3群の少なくともいずれかで、気孔開度分布が異なりました。個別の群間差を判定するには多重比較が必要です。",
      results: [
        {
          key: "control",
          label: "Control",
          images: 5,
          detected: 508,
          open: 215,
          closed: 293,
          openRate: 42.3228,
          median: 0.0,
          mean: 2.15868,
          sd: 2.73048,
          q1: 0.0,
          q3: 4.55368,
        },
        {
          key: "a",
          label: "バイオスティミュラントA剤",
          images: 3,
          detected: 284,
          open: 270,
          closed: 14,
          openRate: 95.0704,
          median: 4.13167,
          mean: 4.0794,
          sd: 1.43998,
          q1: 3.27105,
          q3: 4.98153,
        },
        {
          key: "b",
          label: "バイオスティミュラントB剤",
          images: 4,
          detected: 303,
          open: 288,
          closed: 15,
          openRate: 95.0495,
          median: 4.13657,
          mean: 4.15105,
          sd: 1.49411,
          q1: 3.42659,
          q3: 5.01045,
        },
      ],
    },
    {
      key: "1130",
      label: "11:30頃",
      shortLabel: "11:30",
      window: "11:24:31–11:40:21",
      substrate: "約10:00の再灌水後",
      pValue: 1.4558828091e-36,
      pDisplay: "p < 0.0001",
      significant: true,
      eyebrow: "POST-REWATERING / HIGH TEMPERATURE",
      title: "再灌水後、ControlのOpen率は回復し、B剤は最大の開度を示した。",
      description:
        "10:00頃の十分な再灌水から約1時間半後。ControlのOpen率は84.0%へ戻り、B剤はOpen率98.4%、中央値5.40 µmでした。",
      plantImage: case02Plant1130,
      analysisImage: case02Analysis1130,
      plantCaption:
        "11:38頃の植物体写真。11:23頃の温度計表示は45.1°Cでした。",
      analysisCaption:
        "ControlはOpen率84.0%、中央値3.42 µm。A剤は84.3%、4.24 µm。B剤は98.4%、5.40 µmでした。",
      statisticsNote:
        "3群の少なくともいずれかで、気孔開度分布が異なりました。個別の群間差を判定するには多重比較が必要です。",
      results: [
        {
          key: "control",
          label: "Control",
          images: 5,
          detected: 507,
          open: 426,
          closed: 81,
          openRate: 84.0237,
          median: 3.42118,
          mean: 3.55999,
          sd: 2.11563,
          q1: 2.54558,
          q3: 5.09117,
        },
        {
          key: "a",
          label: "バイオスティミュラントA剤",
          images: 6,
          detected: 553,
          open: 466,
          closed: 87,
          openRate: 84.2676,
          median: 4.24459,
          mean: 4.0481,
          sd: 2.25852,
          q1: 2.91232,
          q3: 5.6921,
        },
        {
          key: "b",
          label: "バイオスティミュラントB剤",
          images: 4,
          detected: 369,
          open: 363,
          closed: 6,
          openRate: 98.374,
          median: 5.4,
          mean: 5.37747,
          sd: 1.63459,
          q1: 4.34334,
          q3: 6.36519,
        },
      ],
    },
  ],
  relatedObservation: {
    key: "0714",
    date: "2026.07.14",
    label: "7/14 11:00頃",
    shortLabel: "7/14 11:00",
    window: "10:57:59–11:06:14",
    photoTime: "10:58",
    substrate:
      "約4:00の灌水後は無灌水。測定時、培地は空に近い乾燥状態。",
    appearance:
      "植物体には萎れが確認された。",
    pValue: 1.2381058386e-27,
    pDisplay: "p < 0.0001",
    significant: true,
    eyebrow: "RELATED OBSERVATION / JULY 14",
    title: "萎れが見えていても、すべての処理区が同じように気孔を閉じてはいなかった。",
    description:
      "7月14日は4:00頃の灌水後に追加灌水を行わず、11:00頃には培地が空に近い乾燥状態となり、植物体に萎れが観察されました。ほぼ同時刻の気孔解析では、ControlとA剤が90%以上Openだった一方、B剤は67.3%でした。",
    plantImage: case02Plant0714,
    analysisImage: case02Analysis0714,
    plantCaption:
      "2026年7月14日10:58の植物体写真。栽培記録では約4:00の灌水後は無灌水で、測定時には培地乾燥と萎れを確認。",
    analysisCaption:
      "気孔画像は10:57:59〜11:06:14に取得。Control 91.9%、A剤96.2%、B剤67.3% Open。中央値は3.99、4.50、2.86 µmでした。",
    statisticsNote:
      "3群の少なくともいずれかで、気孔開度分布が異なりました。個別の群間差には多重比較が必要です。",
    images: 8,
    detected: 823,
    results: [
      {
        key: "control",
        label: "Control",
        images: 3,
        detected: 274,
        open: 252,
        closed: 22,
        openRate: 91.9708,
        median: 3.9931,
        mean: 3.94472,
        sd: 1.73082,
        q1: 3.02801,
        q3: 5.11062,
      },
      {
        key: "a",
        label: "バイオスティミュラントA剤",
        images: 2,
        detected: 185,
        open: 178,
        closed: 7,
        openRate: 96.2162,
        median: 4.5,
        mean: 4.88094,
        sd: 2.06003,
        q1: 3.50018,
        q3: 6.3,
      },
      {
        key: "b",
        label: "バイオスティミュラントB剤",
        images: 3,
        detected: 364,
        open: 245,
        closed: 119,
        openRate: 67.3077,
        median: 2.86378,
        mean: 2.64474,
        sd: 2.17742,
        q1: 0.0,
        q3: 4.22617,
      },
    ],
  },
  transitions: [
    {
      key: "control",
      label: "Control",
      first: { openDelta: -30.2365, medianDelta: -2.84605 },
      second: { openDelta: 41.7008, medianDelta: 3.42118 },
    },
    {
      key: "a",
      label: "バイオスティミュラントA剤",
      first: { openDelta: 13.4234, medianDelta: 1.31423 },
      second: { openDelta: -10.8028, medianDelta: 0.11292 },
    },
    {
      key: "b",
      label: "バイオスティミュラントB剤",
      first: { openDelta: 13.5517, medianDelta: 1.27279 },
      second: { openDelta: 3.3245, medianDelta: 1.26343 },
    },
  ],
};

export const CASE03 = {
  id: "03",
  title: "商業栽培トマト圃場での大量計測",
  lead:
    "2026年2月19日、商業栽培トマト圃場で6:30〜12:00の約5.5時間にわたり、同一栽培条件の多数株から異なる葉をランダムにサンプリングしました。気孔Open率、開度分布、PPFD、光合成速度、温湿度、VPD、CO₂を同じ時間軸に統合しています。",
  question:
    "植物群の朝の変化を大量計測すると、Openになる気孔の割合と、Open気孔の開度分布はどのような順序で変化し、光合成速度とどのように並んで推移するのか。",
  field: {
    date: "2026.02.19",
    window: "06:30–12:00",
    sampling:
      "同一栽培条件の多数株から異なる葉をランダムにサンプリング。",
  },
  images: {
    trend: case03Chart,
    flyer: case03Flyer,
    flyerPdf: case03FlyerPdf,
  },
  rows: [
    {
      time: "06:00",
      timeLabel: "6時台",
      allMedian: 0.0,
      openMedian: 3.1475,
      leafMeanOpenRate: 24.269,
      pooledOpenRate: 36.1854,
      leaves: 46,
      stomata: 1122,
      ppfd: 11.7861,
      photosynthesis: 1.9194,
      gasN: 10,
      temperature: 7.7933,
      rh: 71.8667,
      vpd: 0.2976,
      co2: 933.2133,
    },
    {
      time: "07:00",
      timeLabel: "7時台",
      allMedian: 0.0,
      openMedian: 3.0911,
      leafMeanOpenRate: 42.3377,
      pooledOpenRate: null,
      leaves: 70,
      stomata: 2837,
      ppfd: 79.687,
      photosynthesis: 6.6264,
      gasN: 49,
      temperature: 13.2936,
      rh: 70.6944,
      vpd: 0.4474,
      co2: 886.9972,
    },
    {
      time: "08:00",
      timeLabel: "8時台",
      allMedian: 0.0,
      openMedian: 3.1135,
      leafMeanOpenRate: 48.0037,
      pooledOpenRate: null,
      leaves: 56,
      stomata: 3076,
      ppfd: 221.2267,
      photosynthesis: 13.0399,
      gasN: 52,
      temperature: 24.7556,
      rh: 48.4556,
      vpd: 1.6092,
      co2: 855.2278,
    },
    {
      time: "09:00",
      timeLabel: "9時台",
      allMedian: 2.7006,
      openMedian: 3.1749,
      leafMeanOpenRate: 69.3649,
      pooledOpenRate: 61.5465,
      leaves: 24,
      stomata: 957,
      ppfd: 353.4249,
      photosynthesis: 17.5157,
      gasN: 31,
      temperature: 32.705,
      rh: 40.0472,
      vpd: 2.9662,
      co2: 509.7278,
    },
    {
      time: "10:00",
      timeLabel: "10時台",
      allMedian: 3.6,
      openMedian: 3.6766,
      leafMeanOpenRate: 94.8718,
      pooledOpenRate: null,
      leaves: 49,
      stomata: 3082,
      ppfd: 430.8666,
      photosynthesis: 21.9149,
      gasN: 52,
      temperature: 36.3231,
      rh: 35.075,
      vpd: 3.9261,
      co2: 403.975,
    },
    {
      time: "11:00",
      timeLabel: "11時台",
      allMedian: 4.0441,
      openMedian: 4.0531,
      leafMeanOpenRate: 95.4823,
      pooledOpenRate: null,
      leaves: 44,
      stomata: 2903,
      ppfd: 450.9539,
      photosynthesis: 20.4292,
      gasN: 64,
      temperature: 36.0047,
      rh: 31.0444,
      vpd: 4.0977,
      co2: 467.9833,
    },
    {
      time: "12:00",
      timeLabel: "12時台",
      allMedian: 4.34,
      openMedian: 4.3968,
      leafMeanOpenRate: 95.9145,
      pooledOpenRate: 96.2457,
      leaves: 6,
      stomata: 586,
      ppfd: 629.5621,
      photosynthesis: 21.3241,
      gasN: 7,
      temperature: 31.6578,
      rh: 19.5861,
      vpd: 3.7502,
      co2: 503.5972,
    },
  ],
  representativeSnapshots: [
    {
      time: "06:00",
      timeLabel: "6時台",
      stomata: 1122,
      open: 406,
      closed: 716,
      pooledOpenRate: 36.1854,
      allMedian: 0.0,
      openMedian: 3.2981,
    },
    {
      time: "09:00",
      timeLabel: "9時台",
      stomata: 957,
      open: 589,
      closed: 368,
      pooledOpenRate: 61.5465,
      allMedian: 2.5893,
      openMedian: 3.2066,
    },
    {
      time: "12:00",
      timeLabel: "12時台",
      stomata: 586,
      open: 564,
      closed: 22,
      pooledOpenRate: 96.2457,
      allMedian: 4.3056,
      openMedian: 4.3842,
    },
  ],
  totals: {
    timePoints: 7,
    sampledLeaves: 296,
    analyzedLeaves: 295,
    stomata: 14563,
    gasMeasurements: 265,
    durationHours: 5.5,
    throughputPerHour: 2647,
  },
};